// Smooth scroll
document.documentElement.style.scrollBehavior = 'smooth';

// Fade-in on scroll
const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('is-visible');
    }
  });
}, { threshold: 0.1 });

document.querySelectorAll('.fade-in-section').forEach(el => observer.observe(el));

// Parallax
window.addEventListener('scroll', () => {
  document.querySelectorAll('.parallax-section').forEach(section => {
    const rate = window.scrollY * 0.35;
    section.style.backgroundPositionY = -rate + 'px';
  });
});

// Hover on product cards
document.querySelectorAll('.card__inner, .card-wrapper').forEach(card => {
  card.addEventListener('mouseenter', () => {
    card.style.transform = 'translateY(-6px)';
    card.style.transition = 'transform 0.3s ease, box-shadow 0.3s ease';
    card.style.boxShadow = '0 12px 32px rgba(0,0,0,0.10)';
  });
  card.addEventListener('mouseleave', () => {
    card.style.transform = 'translateY(0)';
    card.style.boxShadow = 'none';
  });
});
// Luxury floating particles
(function() {
  const hero = document.querySelector('.slideshow, .banner, [class*="slideshow__slide"], .hero');
  if (!hero) return;

  const canvas = document.createElement('canvas');
  canvas.id = 'luxury-particles';
  hero.appendChild(canvas);

  const ctx = canvas.getContext('2d');
  let particles = [];

  function resize() {
    canvas.width = hero.offsetWidth;
    canvas.height = hero.offsetHeight;
  }
  resize();
  window.addEventListener('resize', resize);

  function randomBetween(a, b) { return a + Math.random() * (b - a); }

  for (let i = 0; i < 38; i++) {
    particles.push({
      x: randomBetween(0, canvas.width),
      y: randomBetween(0, canvas.height),
      r: randomBetween(0.5, 2.2),
      alpha: randomBetween(0.2, 0.8),
      speed: randomBetween(0.15, 0.45),
      drift: randomBetween(-0.2, 0.2),
      gold: Math.random() > 0.7
    });
  }

  function draw() {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    particles.forEach(p => {
      ctx.beginPath();
      ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
      ctx.fillStyle = p.gold
        ? `rgba(212, 175, 100, ${p.alpha})`
        : `rgba(255, 255, 255, ${p.alpha})`;
      ctx.shadowBlur = 8;
      ctx.shadowColor = p.gold ? 'rgba(212,175,100,0.6)' : 'rgba(255,255,255,0.6)';
      ctx.fill();

      p.y -= p.speed;
      p.x += p.drift;
      p.alpha += Math.sin(Date.now() * 0.001 + p.x) * 0.005;

      if (p.y < -5) {
        p.y = canvas.height + 5;
        p.x = randomBetween(0, canvas.width);
      }
    });
    requestAnimationFrame(draw);
  }
  draw();
})();
